import * as actionTypes from './actiontypes';
import * as API from './api';
import { showMessage, log } from '../../config/utils';

export const updateDowntimeState = (payload, path) => {
  return {
    type: actionTypes.UPDATE_DOWNTIME_STATE,
    payload,
    path
  };
}

export const fetchDowntimeList = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.DOWNTIME_LOADING,
    });
    API.fetchDowntimeList({}, (error, response) => {
      log('get all downtime response:', response);
      if (!error && response && response.data) {
        dispatch({
          type: actionTypes.DOWNTIME_LOADED,
          payload: response.data,
        });
      } else {
        dispatch({
          type: actionTypes.DOWNTIME_LOAD_ERROR,
        });
      }
    });
  };
}

export const createDowntime = (data, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_DOWNTIME_STATE,
      payload: true,
      path: 'loaders.downtime_updating'
    });
    API.createDowntime(data, (error, response) => {
      log('create new Downtime response:', response);
      if (!error && response && response.data && response.data.downTime) {
        dispatch({
          type: actionTypes.DOWNTIME_CREATED,
          payload: response.data.downTime,
        });
        if (callback) callback();
        showMessage('success', response.message ? response.message : 'Tag has been successfully created!');
      }
      dispatch({
        type: actionTypes.UPDATE_DOWNTIME_STATE,
        payload: false,
        path: 'loaders.downtime_updating'
      });
    });
  };
}

export const updateDowntime = (data, callback) => {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_DOWNTIME_STATE,
      payload: true,
      path: 'loaders.downtime_updating'
    });
    API.updateDowntime(data, (error, response) => {
      log('update new Downtime response:', response);
      if (!error && response && response.data && response.data.downTime) {
        dispatch({
          type: actionTypes.DOWNTIME_UPDATED,
          payload: response.data.downTime,
        });
        if (callback) callback();
        showMessage('success', response.message ? response.message : 'Tag has been successfully updated!');
      }
      dispatch({
        type: actionTypes.UPDATE_DOWNTIME_STATE,
        payload: false,
        path: 'loaders.downtime_updating'
      });
    });
  };
}



// WEBPACK FOOTER //
// ./src/data/redux/downtime_details/actions.js